import { AxiosError } from 'axios';
import { ServerResponse, WithAuditDetails } from 'data/types';
import { History } from 'history';
import { Dispatch, Action } from 'redux';
import { RootState } from 'data/root.reducers';
import i18n from 'i18n';
import { showSuccessMessage, showError } from 'shared/toaster';
import { ThunkDispatch } from 'redux-thunk';
import * as api from './securityPolicy.api';
import {
  GET_SECURITY_POLICY,
  GetSecurityPolicyAction,
  GO_TO_SECURITY_POLICY_EDIT,
  GO_TO_SECURITY_POLICY_VIEW,
  UPDATE_SECURITY_POLICY,
  UPDATE_ERRORS,
  SecurityPolicy,
  UpdateSecurityPolicyThunkAction,
} from './securityPolicy.types';
import { SECURITY_POLICY_ROUTE } from '../../constants';
import { extractErrorMessage } from '../../utils';

export function updateSecurityPolicyErrors(errors: { securityPolicy: string }): (dispatch: Dispatch) => void {
  return (dispatch: Dispatch) => {
    dispatch({
      type: UPDATE_ERRORS,
      payload: errors
    });
  };
}

export function goToSecurityPolicyEdit(history: History): (dispatch: Dispatch) => void {
  return (dispatch: Dispatch) => {
    dispatch({
      type: GO_TO_SECURITY_POLICY_EDIT,
    });

    history.push(`${SECURITY_POLICY_ROUTE}/edit`);
  };
}

export function goToSecurityPolicyView(history: History): (dispatch: Dispatch) => void {
  return (dispatch: Dispatch) => {
    dispatch({
      type: GO_TO_SECURITY_POLICY_VIEW,
    });

    history.push(`${SECURITY_POLICY_ROUTE}`);
  };
}

export function getSecurityPolicy(deliveryFunctionId: string): GetSecurityPolicyAction {
  return {
    type: GET_SECURITY_POLICY,
    payload: api.getSecurityPolicy(deliveryFunctionId),
  };
}

export function updateSecurityPolicy(
  deliveryFunctionId: string,
  securityPolicyBody: WithAuditDetails<SecurityPolicy[]>,
  history: History,
): UpdateSecurityPolicyThunkAction {
  return async (dispatch: ThunkDispatch<RootState, unknown, Action<string>>) => {
    const errors = { securityPolicy: '' };

    try {
      await dispatch({
        type: UPDATE_SECURITY_POLICY,
        payload: api.updateSecurityPolicy(deliveryFunctionId, securityPolicyBody.data[0].name, securityPolicyBody),
      });
    } catch (e) {
      const errorMessage = extractErrorMessage(e as AxiosError<ServerResponse<void>>);
      errors.securityPolicy = i18n.t('securityPolicy.edit.failed', { name: securityPolicyBody.data[0].name, error: errorMessage });
    }

    if (errors.securityPolicy === '') {
      showSuccessMessage(i18n.t('securityPolicy.edit.success', { name: securityPolicyBody.data[0].name }));
    }

    if (errors.securityPolicy !== '') {
      const error = errors.securityPolicy;
      showError(i18n.t('securityPolicy.edit.failed', { error }));
    } else {
      dispatch(goToSecurityPolicyView(history));
    }

    dispatch(updateSecurityPolicyErrors(errors));
  };
}
